<template>
  <div class="portal-body">
      <header-portal></header-portal>
    <v-content class="content-top" v-if="isPrincipal">
      <v-layout class="row">
          <div class="column-left">
              <span class="text-huge">DJBR</span>
          </div>
          <div class="column-right">
              <div class="text-big">DECLARACIÓN JURADA</div>
              <br>
              <div class="text-big">DE BIENES Y RENTAS TRADICIONAL</div>
          </div>
      </v-layout>
      <div class="portal-background-opacity">
        <v-container grid-list-md text-xs-center>
        <v-layout class="padding mt-0" row wrap align-center justify-center>
          <v-flex>
            <v-btn class="tamanioBotonTradicional" color="primary" :loading="loading" :disabled="loading" dark large @click="authenticateTradicional(1), loader = 'loading'">
              <b>Ingresar Con:<br>
                CUENTA</b>&nbsp;
              <v-icon right dark>touch_app</v-icon>
              <template v-slot:loader>
                <span>Redirigiendo...</span>
              </template>
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn class="tamanioBotonTradicional" color="primary" :loading="loading" :disabled="loading" dark large @click="authenticateTradicional(2), loader = 'loading'">
              <b>Ingresar Con:<br>
                TARJETA
              </b>&nbsp;
              <v-icon right dark>touch_app</v-icon>
              <template v-slot:loader>
                <span>Redirigiendo...</span>
              </template>
            </v-btn>
          </v-flex>
          <login-djbr v-if="tipo_ingreso === 1" :key="contador" :alerta=true></login-djbr>
          <login-tarjeta v-if="tipo_ingreso === 2" :key="contador" :alerta=true></login-tarjeta>
        </v-layout>
        </v-container>
        <aside-portal></aside-portal>
      </div>
    </v-content>
    <preguntas-frecuentes v-if="isPreguntas"/>
    <informacion v-if="isInformacion"/>
    <contacto v-if="isContacto"/>
    <base-legal v-if="isBaseLegal"/>
    <manuales v-if="isManuales"/>
    <v-footer
      :fixed="false"
      height="40"
      app
      dark
      color="gray"
      padless
      class="footer"
    >
      <v-layout align-center justify-center>
        <v-flex class="text-xs-center">
          <strong>{{ new Date().getFullYear() }} — Contraloría General del Estado</strong>
        </v-flex>
      </v-layout>
    </v-footer>
    <global-comunicado v-if="comunicados.length > 0"></global-comunicado>
  </div>
</template>

<script>
import HeaderPortal from '@/components/djbrd/headerPortal.vue';
import AsidePortal from '@/components/djbrd/asidePortal.vue';
import BaseLegal from '@/components/portal/baseLegal.vue';
import Auth from '../admin/auth/mixins/auth.js';
import LoginDjbr from '@/components/portal/login/LoginDjbr.vue';
import LoginTarjeta from '@/components/portal/login/LoginTarjeta.vue';
import PreguntasFrecuentes from '@/components/djbrd/PreguntasFrecuentes';
import Informacion from '@/components/djbrd/Informacion';
import Contacto from '@/components/djbrd/Contacto';
import Manuales from '@/components/djbrd/Manuales';
import GlobalComunicado from '@/components/portal/globalComunicado.vue';
export default {
  mixins: [ Auth ],
  components: {
    HeaderPortal,
    AsidePortal,
    BaseLegal,
    LoginDjbr,
    LoginTarjeta,
    PreguntasFrecuentes,
    Informacion,
    Contacto,
    Manuales,
    GlobalComunicado
  },
  created () {
    if (this.$storage.existUser()) {
      this.logout();
    }
    this.verificarBrowser();
  },
  data: () => ({
    comunicados: GlobalComunicado.data().comunicados,
    loading: false,
    activeBtn: 1,
    repetidosModal: true,
    isPrincipal: true,
    isPreguntas: false,
    isInformacion: false,
    isContacto: false,
    isBaseLegal: false,
    isManuales: false,
    tipo_ingreso: 0,
    contador: 0
  }),
  mounted () {
    this.$root.$on('onOpcionPortal', (value) => {
      this.cambiarOpcionPortal(value);
    });
  },
  methods: {
    renderizar () {
      this.contador += 1;
    },
    authenticateTradicional (ingreso) {
      this.loading = true;
      setTimeout(() => {
        this.renderizar();
        this.tipo_ingreso = ingreso;
        this.loading = false;
      }, 1);
    },
    authenticate () {
      this.loading = true;
      setTimeout(() => {
        this.getCode();
        this.loading = false;
      }, 2000);
    },
    /* eslint-disable */
    verificarBrowser () {
      navigator.sayswho = (function () {
        let ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
      })();
      if (navigator.sayswho.indexOf('Opera') !== -1 || navigator.sayswho.indexOf('IE') !== -1 || navigator.sayswho.indexOf('Safari 9') !== -1) {
        this.$message['warning']('Navegador no soportado para el sistema, debe utilizar Firefox o Chrome para que el sistema funcione correctamente');
      }
    },
    cambiarOpcionPortal (value) {
      switch (value) {
        case 'principal':
          this.isPrincipal = true;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'preguntas':
          this.isPrincipal = false;
          this.isPreguntas = true;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'informacion':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = true;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'contacto':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = true;
          this.isBaseLegal = false;
          this.isManuales = false;
          break;
        case 'base-legal':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = true;
          this.isManuales = false;
          break;
        case 'manuales':
          this.isPrincipal = false;
          this.isPreguntas = false;
          this.isInformacion = false;
          this.isContacto = false;
          this.isBaseLegal = false;
          this.isManuales = true;
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang='scss'>
.v-btn--large { 
  font-size: 20px !important; 
  height: 80px !important; 
  padding: 10px 40px !important; 
}
.footer {
  font-size: 12px;
}
.padding {
  padding-top: 2.0%;
  padding-right: 10px;
  padding-bottom: 5%;
  padding-left: 10px;
}

.pdf-view .pdf-view-actions .pdf-view-buttons .visible {
  visibility: hidden !important;
}
body .application main .main {
    padding: 0px 0px;
}
.portal-body {
  background-image:  linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.11),
      rgba(0, 0, 0, 0.11)
    ), url(../../assets/images/home.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  height: fit-content;
}
.text-huge{
  color: white;
  font-size: 120px;
  font-weight: 100;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
}
.text-big{
  color: white;
  font-size: 40px;
  font-weight: 100;
  font-family: Arial, Helvetica, sans-serif;
  display: inline-block;
}
.text-medium{
  color: white;
  font-size: 20px;
}
.icono{
  color: white;
  size: 120px;
}
.column-left {
  float: left;
  width: 30%;
  text-align: right;
}
.column-right {
  float: left;
  width: 70%;
  text-align: left;
  padding-top:42px;
  line-height: normal;
}
.row:after {
  content: "";
  // display: table;
  clear: both;
  display:table-cell;
  vertical-align:middle;
}
.portal-background-opacity{
  background-color: #19345b;
  opacity: 0.8;
  background-size: auto;
}
@media (max-width: 900px) {
  .padding {
    padding-top: 10%;
    padding-right: 10px;
    padding-bottom: 5%;
    padding-left: 10px;
  }
  .text-big{
    color: white;
    font-size: 30px;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
  }
  .text-huge{
    color: white;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 80px;
  }
  .text-medium{
    color: white;
    font-size: 12px;
  }
  .column-right {
  float: left;
  width: 70%;
  text-align: left;
  padding-top:23px;
  line-height: normal;
  }
}
@media (max-width: 600px) {
  .padding {
    padding-top: 10%;
    padding-right: 10px;
    padding-bottom: 20%;
    padding-left: 10px;
  }
  .text-big{
    color: white;
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
  }
  .text-huge{
    color: white;
    font-weight: 100;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 45px;
  }
  .text-medium{
    color: white;
    font-size: 12px;
  }
  .column-right {
  float: left;
  width: 70%;
  text-align: left;
  padding-top:8px;
  line-height: normal;
  }
}
.image {
  width: 281px;
  height: 55px;
  background-image: url(../../assets/images/logo.png);
  float: inherit;
}
/*
.padding-space {
  padding-top: 10px;
  padding-bottom: 10px;
}
*/
.opcion-declarar {
  padding-top: 30px;
}
.content-top {
  padding: 64px 0px 48px !important;
}
@media (max-width: 1300px) {
  .content-top {
    padding: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/djbrd/portalTradicional.vue